import type { MonospacePage } from '#layers/data-model/public';
import { computed } from 'vue';
import { createError } from '#app/composables/error';
import { useRoute } from '#app/composables/router';
import { useWorkspaceEntityStore } from '#layers/runtime/public';
import { getGeneratedContentPage } from '#layers/spaces/utils/content-pages';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useGeneratedContentRoutePage(type: NonNullable<MonospacePage['type']>, intent: MonospacePage['intent'] = null) {
	const route = useRoute();
	const store = useWorkspaceEntityStore();
	const schemaStore = useWorkspaceSchemaStore();

	return computed(() => {
		const collectionName = route.params.collection as string | undefined;
		const collection = collectionName ? schemaStore.findCollectionByName(collectionName) : undefined;
		const generatedPage = collection
			? getGeneratedContentPage(store, {
					collectionId: collection.id,
					type,
					intent,
				})
			: undefined;

		if (!generatedPage) {
			throw createError({ status: 404 });
		}

		return generatedPage;
	});
}
